import axios from 'axios'

const TAG = process.env.VUE_APP_TAG;

class TagCalls {

  addChapterTags(chapterId, tags) {
    return axios.post(TAG + `chapters/id/${chapterId}`, { tags: tags })
    .then(response => response.data.chapterTags);
  }

}

const tagCalls = new TagCalls();
export default tagCalls;
